<template>
    <div v-show="show" :class="{'createTimeOutListDetail-container': true, breaking: config.activeTab != 'punctual'}">
        <div class="dialogContent">
            <div class="title">{{config.activeTab == 'punctual' ? '定时单查看' : '突发单查看'}}</div>
            <img @click="cancel" class="close" src="./assets/close.png" alt="">
            <div class="content">
                <div class="left-container">
                    <img v-if="detail.img_url" :src="detail.img_url" alt="头图内容">
                    <div v-else class="noImg">
                        <i></i>
                        <span>无图片</span>
                    </div>
                    <div :class="{wordBg: true, on: config.activeTab == 'punctual'}"><i></i>{{detail.title}}</div>
                    <div class="mainContent">{{ detail.content }}</div>
                    <div class="notice">
                        <i></i>
                        <span>该预览仅展示文字与图片的布局，实际底版配色以上屏为准</span>
                    </div>
                </div>
                <div class="right-container">
                    <div class="title">{{detail.title}}</div>
                    <div v-show="config.activeTab == 'punctual'" class="row">
                        <span>上屏时间：</span>
                        <p>{{detail.screen_time}}</p>
                    </div>
                    <div v-show="config.activeTab == 'punctual'" class="row">
                        <span>优先级：</span>
                        <p>{{detail.priority}}</p>
                    </div>
                    <div v-show="detail.screen_time_data && detail.screen_time_data.length && config.activeTab == 'punctual'" class="row">
                        <span>循环上屏：</span>
                        <div>
                            <p>{{detail.screen_time}}</p>
                            <i></i>
                            <div class="info">
                                <span>循环上屏时间</span>
                                <p v-for="(item, index) in detail.screen_time_data" :key="index">{{item}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="infoTitle">其他信息</div>
                    <div class="info">
                        <div class="row">
                            <span>创建时间：</span>
                            <p>{{detail.raw_add_time}}</p>
                        </div>
                        <div class="row">
                            <span>创建人：</span>
                            <p>{{detail.creater_name}}</p>
                        </div>
                        <div class="row">
                            <span>提交时间：</span>
                            <p>{{detail.submit_time}}</p>
                        </div>
                        <div class="row">
                            <span>任务状态：</span>
                            <p :class="{g: detail.status == 2, r: detail.status == 4}">
                                <el-tooltip :content="detail.error_text" :disabled="detail.status != 4" placement="bottom">
                                    <span>{{detail.status_text}}</span>
                                </el-tooltip>
                            </p>
                        </div>
                        <div class="row">
                            <span>关联内容：</span>
                            <p @click="toDetail(detail.unified_content_id)" class="a">{{detail.doc_title}}</p>
                        </div>
                        <div class="row">
                            <span>事件发生时间：</span>
                            <p>{{detail.happy_time}}</p>
                        </div>
                        <div v-show="detail.withdraw_time && config.activeTab == 'punctual'" class="row">
                            <span>撤回时间：</span>
                            <p>{{detail.withdraw_time}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import { Switch } from 'element-ui'
import { apis } from "@common/config";
import common from "@common/common";
export default {
    components: {
        DatePicker,
        'el-switch': Switch
    },
    data() {
        return {
            detail: {},
            cover: '',
            placeholder: '',
            show: false,
            config: {},
            callback: null,
            title: '退回理由',
            canEdit: true,
            maxLength: 100,
            num: 0,
            content: '',
            singleBtn: false,
            errTitle: '退回理由不能为空',
            times: "1",
            date: "15",
            priority: '',
            isCycle: false,
            datePicker: ''
        }
    },
    methods: {
        toDetail(id){
            common.jumpOut(
             `/unifiedContentLibrary/content/doc/detail/${id}`
            );
        },
        open(config, callback) {
            this.config = config;
            this.callback = callback;
            this.show = true;
            this.getDetail()
        },
        confirm() {
            
        },
        cancel() {
            this.show = false;
            this.callback(false)
        },
        async close() {
            this.show = false;
        },
        getDetail(){
            let data = {
                id: this.config.id,
                consult_type: this.config.activeTab == 'punctual' ? 1 : 2
            }
            common.myFetch(apis.consultDetail,data).then(res => {
                if (res) {
                    this.detail = res
                }
            })
            
        }
    }
}
</script>

<style lang="less">
    @font-face {
        font-family: 'HYQiHei70S';
        src: url('/font/SourceHanSansCN-Bold.otf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    // 汉仪旗黑70s字体类
    .hyqihei70s {
        font-family: 'HYQiHei70S', sans-serif;
    }

    .createTimeOutListDetail-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        &.breaking {
            .dialogContent {
                width: 797px;
                height: 664px;

                .content {
                    .left-container {
                        display: flex;
                        flex-direction: column;
                        margin-right: 40px;

                        img {
                            min-width: 277px;
                            min-height: 156px;
                            max-width: 277px;
                            max-height: 156px;
                        }

                        .noImg {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            min-width: 277px;
                            min-height: 156px;
                            max-width: 277px;
                            max-height: 156px;
                            background: #E7EBEB;

                            i {
                                display: block;
                                width: 20px;
                                height: 20px;
                                background: url('./assets/noImg.png') no-repeat;
                                background-size: cover;
                                background-position: center;
                                margin-bottom: 6px;
                            }

                            span {
                                font-size: 14px;
                                color: #C4CBD1;
                                line-height: 20px;
                            }
                        }

                        .wordBg {
                            position: relative;
                            display: flex;
                            align-items: flex-start;
                            flex-wrap: wrap;
                            width: 277px;
                            height: 58px;
                            background: #39464F;
                            font-family: 'HYQiHei70S', sans-serif;
                            font-weight: bold;
                            font-size: 21px;
                            color: #FFFFFF;
                            line-height: 26px;
                            text-align: left;
                            font-style: normal;
                            letter-spacing: 0px;
                            padding: 6px 60px 0px 4px !important;
                            box-sizing: border-box;
                            white-space: pre-wrap;
                            word-break: break-all;
                            overflow: hidden;
                            text-indent: 24px;

                            i {
                                position: absolute;
                                display: flex;
                                width: 9px;
                                height: 14px;
                                background: url('./assets/arrow1.png') no-repeat;
                                background-position: center;
                                background-size: 100%;
                                top: 9px;
                                left: 10px;
                            }
                        }

                        .mainContent {
                            position: relative;
                            display: flex;
                            align-items: flex-start;
                            flex-wrap: wrap;
                            width: 277px;
                            height: 260px;
                            background: #39464F;
                            font-family: 'HYQiHei70normal', sans-serif;
                            font-weight: 400;
                            font-size: 19px;
                            color: #FFFFFF;
                            line-height: 27px;
                            text-align: left;
                            font-style: normal;
                            letter-spacing: -0.2px;
                            padding: 13px 75px 0px 4px !important;
                            box-sizing: border-box;
                            white-space: pre-wrap;
                            word-break: break-all;
                            overflow: hidden;
                        }

                        .notice {
                            display: flex;
                            align-items: center;
                            margin-top: 14px;
                            width: 277px;

                            i {
                                width: 14px;
                                height: 14px;
                                background: url('./assets/notice.png') no-repeat;
                                background-size: cover;
                                margin-right: 8px;
                            }

                            span {
                                font-weight: 500;
                                font-size: 14px;
                                color: #666666;
                                line-height: 22px;
                            }
                        }
                    }
                }
            }
        }

        .dialogContent {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 1032px;
            height: 623px;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            padding: 20px 30px 40px;
            box-sizing: border-box;

            &>.title {
                font-size: 24px;
                line-height: 33px;
                color: #050F0F;
                font-weight: bold;
                margin-bottom: 30px;
            }

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                width: 21px;
                height: 21px;
                user-select: none;
                cursor: pointer;
            }

            .content {
                display: flex;
                width: 100%;
                flex: 1;
                min-height: 0;

                .left-container {
                    display: flex;
                    flex-direction: column;
                    margin-right: 40px;

                    img {
                        min-width: 512px;
                        min-height: 289px;
                        max-width: 512px;
                        max-height: 289px;
                    }

                    .noImg {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        min-width: 512px;
                        min-height: 289px;
                        max-width: 512px;
                        max-height: 289px;
                        background: #E7EBEB;

                        i {
                            display: block;
                            width: 20px;
                            height: 20px;
                            background: url('./assets/noImg.png') no-repeat;
                            background-size: cover;
                            background-position: center;
                            margin-bottom: 6px;
                        }

                        span {
                            font-size: 14px;
                            color: #C4CBD1;
                            line-height: 20px;
                        }
                    }

                    .wordBg {
                        position: relative;
                        display: flex;
                        align-items: flex-start;
                        flex-wrap: wrap;
                        width: 512px;
                        height: 108px;
                        background: #39464F;
                        font-family: 'HYQiHei70S', sans-serif;
                        font-weight: normal;
                        font-size: 40px;
                        color: #FFFFFF;
                        line-height: 48px;
                        text-align: left;
                        font-style: normal;
                        letter-spacing: -2.5px;
                        padding: 8px 10px 0;
                        box-sizing: border-box;
                        white-space: pre-wrap;
                        word-break: break-all;
                        text-indent: 46px;

                        &.on {
                            font-size: 26px;
                            line-height: 44px;
                            letter-spacing: 0px;
                        }

                        i {
                            position: absolute;
                            display: flex;
                            width: 17px;
                            height: 25px;
                            background: url('./assets/arrow1.png') no-repeat;
                            background-position: center;
                            background-size: 100%;
                            top: 20px;
                            left: 21px;
                        }
                    }

                    .notice {
                        display: flex;
                        align-items: center;
                        margin-top: 14px;

                        i {
                            width: 14px;
                            height: 14px;
                            background: url('./assets/notice.png') no-repeat;
                            background-size: cover;
                            margin-right: 8px;
                        }

                        span {
                            font-weight: 500;
                            font-size: 14px;
                            color: #666666;
                            line-height: 22px;
                        }
                    }
                }

                .right-container {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    min-width: 0;

                    .title {
                        font-weight: 500;
                        font-size: 16px;
                        color: #050F0F;
                        line-height: 21px;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        margin-bottom: 10px;
                    }

                    & > .row {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        margin-bottom: 8px;

                        & > span {
                            font-weight: 400;
                            font-size: 13px;
                            color: #829191;
                            line-height: 24px;
                        }

                        & > p {
                            font-weight: 400;
                            font-size: 13px;
                            color: #050F0F;
                            line-height: 24px;
                        }

                        & > div {
                            position: relative;
                            display: flex;
                            align-items: center;

                            &:hover {
                                .info {
                                    display: flex;
                                }
                            }

                            & > p {
                                font-weight: 400;
                                font-size: 13px;
                                color: #050F0F;
                                line-height: 24px;
                                margin-right: 10px;
                            }

                            & > i {
                                display: block;
                                width: 8px;
                                height: 4px;
                                background: url('./assets/arrow.png') no-repeat;
                                background-size: cover;
                                background-position: center;
                            }

                            .info {
                                position: absolute;
                                top: 24px;
                                right: 0;
                                display: none;
                                flex-direction: column;
                                width: 178px;
                                padding: 16px 20px;
                                box-sizing: border-box;
                                background: rgba(5, 15, 15, 0.8);
                                border-radius: 4px;

                                span {
                                    font-weight: 500;
                                    font-size: 14px;
                                    color: #41B48C;
                                    line-height: 20px;
                                    margin-bottom: 10px;
                                }

                                p {
                                    font-size: 14px;
                                    color: #829191;
                                    line-height: 20px;
                                    margin-bottom: 12px;

                                    &:nth-last-of-type(1) {
                                        margin-bottom: 0;
                                    }
                                }
                            }
                        }
                    }

                    .line {
                        width: 100%;
                        height: 1px;
                        background: #DCDCDC;
                        margin: 6px 0 14px;
                    }

                    .infoTitle {
                        font-weight: 500;
                        font-size: 13px;
                        color: #050F0F;
                        line-height: 24px;
                        margin-bottom: 10px;
                    }

                    .info {
                        width: 100%;
                        background: rgba(185,195,195,0.15);
                        padding: 10px 14px;

                        .row {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-bottom: 8px;

                            span {
                                font-weight: 400;
                                font-size: 13px;
                                color: #829191;
                                line-height: 24px;
                                white-space: nowrap;
                            }

                            p {
                                font-weight: 400;
                                font-size: 13px;
                                color: #050F0F;
                                line-height: 24px;

                                &.g {
                                    color: #41B48C;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }

                                &.r {
                                    color: #FF555A;
                                }

                                &.a {
                                    color: #41B48C;
                                    text-decoration: underline;
                                    user-select: none;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
            }

            & > .btns {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 24px auto 0;

                .btn {
                    width: 120px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    background: #B9C3C3;
                    border-radius: 4px;
                    color: #FFF;
                    user-select: none;
                    cursor: pointer;

                    &:nth-of-type(2) {
                        margin-left: 20px;
                    }

                    &.g {
                        background: #41B48C;
                    }
                }
            }
        }
    }

    .timeOutSelect {
        .el-select-dropdown__item.selected {
            color: #41B48C;
        }
    }
</style>